<a routerLink="/extranet">
    <div class="row" id="encabezado_extranet">
        <div class="col-2 navbar_icon"><img src="/assets/icons/icon-acceso-clientes.svg"></div>
        <div class="col-10"><span class="float-right">{{userName}}</span></div>
    </div>
</a>